import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services/api.service';
import { IApiStatus } from '@common/models/IApiStatus';
import { IFundCapitalMember } from '@common/models/ICapitalMember';
import { IFundFamily } from '@common/models/IFundFamily';
import { getLastDateInQuarter, getQuarter } from '@common/services/DateHelper';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FundCapitalMembersService {

  constructor(private readonly apiService: ApiService) { }
   
  public get(): Observable<IFundCapitalMember[]> {
    return this.apiService.get('FundCapitalMember');
  }

  public getLegalEntities(): Observable<any[]> {
    return this.apiService.get('FundCommitment/LegalEntity');
  }
  
  public getFundFamilies(): Observable<IFundFamily[]> {
    return this.apiService.get('FundFamily');
  }
  public getById(id):  Observable<IFundCapitalMember> {
    return this.apiService.get('FundCapitalMember/'+ id);
  }
  public delete(id): Observable<IApiStatus>{
    return this.apiService.delete('FundCapitalMember/'+ id); 
  }
  public update(requestBody: IFundCapitalMember): Observable<IApiStatus> {
    return this.apiService.put('FundCapitalMember' , requestBody); 
  }
  public add(requestBody: IFundCapitalMember): Observable<IApiStatus> {
    return this.apiService.post('FundCapitalMember' , requestBody); 
  }
  public addMany(requestBody: IFundCapitalMember[]): Observable<IApiStatus> {
    return this.apiService.post('FundCapitalMember/bulk' , requestBody); 
  }
  public generateQuarters(){
    let quarters: string[] = [];
    const start: Date = new Date(2010, 0); // Jan 2020
    const end: Date =  new Date();

    // Round the start date to the start of the quarter
    let startQuarter = Math.floor(start.getMonth() / 3);
    let startDate = new Date(start.getFullYear(), startQuarter * 3);

    while (startDate < end) {
      let quarter = Math.floor(startDate.getMonth() / 3) + 1; // +1 because quarters are 1-indexed
      const name = `${startDate.getFullYear()}-Q${quarter}`
      quarters.push(name);
      // Advance to the next quarter
      startDate.setMonth(startDate.getMonth() + 3);
    }
    return quarters;
  }
  generateNextQuarter(date1){
    const today = new Date(date1);
    const quarter = Math.floor(today.getMonth() / 3); let nextQuarterArr = []
        let startDate = new Date(today.getFullYear(), quarter * 3 + (3), 1);
        let endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);
        nextQuarterArr.push({'name' : getQuarter(endDate)})
    return nextQuarterArr
  }
  getNextQuarter(list){
    let nextQuarter = '' ;
    const d = getLastDateInQuarter(list[0]['name']);
    let arr = this.generateNextQuarter(d)
    nextQuarter = arr[0]['name'];
    return nextQuarter ;
  }
  public addNewFund(data, list){
    let nextQuarter: string = this.getNextQuarter(list)
      let newRatio ={
        [nextQuarter]:{
          adjustedGrossMoic: 0,
          adjustedGrossIrr: 0,
          netMoic: 0,
          netIrr: 0 
        }
      }
    data.performanceRatios = Object.assign(data.performanceRatios, newRatio) ;
    let newFundObj ={
      nextQuarter: nextQuarter,
      data: data
    }
    return newFundObj ;
  }
}
